import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import styles from '../index.styl';
import {
  makeSelectComplaintsCounter,
  selectComplaintsLoading,
  selectResolvedList,
  selectUnResolvedList,
} from '../../../redux/complaints/selectors';
import { actions as resolvedListActions } from '../../../redux/complaints/complaintResolvedList';
import { actions as unresolvedListActions } from '../../../redux/complaints/complaintUnResolvedList';

const mapStateToProps = state => ({
  resolvedList: selectResolvedList(state),
  unresolvedList: selectUnResolvedList(state),
  loading: selectComplaintsLoading(state),
  unresolvedCounter: makeSelectComplaintsCounter('unresolved')(state),
  resolvedCounter: makeSelectComplaintsCounter('resolved')(state),
});
const mapDispatchToProps = {
  fetchResolvedList: resolvedListActions.send,
  fetchUnresolvedList: unresolvedListActions.send,
  loadMoreResolved: resolvedListActions.loadMore,
  loadMoreUnresolved: unresolvedListActions.loadMore,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/enhance.js